export default "__VITE_ASSET__DFR89JZj__"